<template>
    <div class="mx-0 my-0 px-0 py-0 col-12 styleguide">
      <NavbarNew></NavbarNew>
      <div class="container-xl mt-5 pb-5">
        <h1>
          Styleguide
        </h1>
        <h6>
          Typografi
        </h6>
        <h1>
          Heading 1
        </h1>
        <h2>
          Heading 2
        </h2>
        <h3>
          Heading 3
        </h3>
        <h4>
          Heading 4
        </h4>
        <p>
          Default font size. Nullam sit amet enim. Suspendisse id velit vitae ligula volutpat condimentum.
          Aliquam erat volutpat. Sed quis velit. Nulla facilisi. Nulla libero. Vivamus pharetra posuere sapien.
          Nam consectetuer. Sed aliquam, nunc eget euismod ullamcorper, lectus nunc ullamcorper orci, fermentum bibendum enim nibh eget ipsum.
        </p>
        <p class="text-md">
          Small font size. Nullam sit amet enim. Suspendisse id velit vitae ligula volutpat condimentum.
          Aliquam erat volutpat. Sed quis velit. Nulla facilisi. Nulla libero. Vivamus pharetra posuere sapien.
          Nam consectetuer. Sed aliquam, nunc eget euismod ullamcorper, lectus nunc ullamcorper orci, fermentum bibendum enim nibh eget ipsum.
        </p>
        <p class="text-sm">
          Extra small font size. Nullam sit amet enim. Suspendisse id velit vitae ligula volutpat condimentum.
          Aliquam erat volutpat. Sed quis velit. Nulla facilisi. Nulla libero. Vivamus pharetra posuere sapien.
          Nam consectetuer. Sed aliquam, nunc eget euismod ullamcorper, lectus nunc ullamcorper orci, fermentum bibendum enim nibh eget ipsum.
        </p>
        <h6>
          Spaltbredd
        </h6>
        <TextContainer>
          The invoice will be sent to the address you have provided. If you alredy have a link to e-invoices via your organisation, the invoice will be sent via that route.
           As part of our enviromental management, we encourage digital invoices. Ensure that you have entered your e-mail if you want to receive the invoice by e-mail.
        </TextContainer>
        <h6>
          Listor
        </h6>
        <TextContainer>
          <p>
            Nullam sit amet enim. Suspendisse id velit vitae ligula volutpat condimentum. Aliquam erat volutpat. Sed quis velit. Nulla facilisi. Nulla libero. Vivamus pharetra posuere sapien.
          </p>
          <ul>
            <li>Lorem ipsum</li>
            <li>Lorem ipsum</li>
            <li>Lorem ipsum</li>
          </ul>
          <p>
            Nullam sit amet enim. Suspendisse id velit vitae ligula volutpat condimentum. Aliquam erat volutpat. Sed quis velit. Nulla facilisi. Nulla libero. Vivamus pharetra posuere sapien.
          </p>
          <ol>
            <li>Lorem ipsum</li>
            <li>Lorem ipsum</li>
            <li>Lorem ipsum</li>
          </ol>
        </TextContainer>
        <h6>
          Färger
        </h6>
        <div class="row mb-5">
          <div class="col">
            <StyleCircle color="#000000" />
          </div>
          <div class="col">
            <StyleCircle color="#FFFFFF" />
          </div>
          <div class="col">
            <StyleCircle color="#007D8F" />
          </div>
          <div class="col">
            <StyleCircle color="#8BCAC1" />
          </div>
          <div class="col">
            <StyleCircle color="#E4F1F4" />
          </div>
        </div>
        <div class="row mb-5">
          <div class="col">
            <StyleCircle color="#fedd75" />
          </div>
          <div class="col">
            <StyleCircle color="#fd5523" />
          </div>
          <div class="col">
            <StyleCircle color="#3478f6" />
          </div>
          <div class="col">
            <StyleCircle color="#1c4587" />
          </div>
          <div class="col">
            <StyleCircle color="#9900ff" />
          </div>
        </div>
        <div class="row mb-5">
          <div class="col">
            <StyleCircle color="#fff7dd" />
          </div>
          <div class="col">
            <StyleCircle color="#ffd5ca" />
          </div>
          <div class="col">
            <StyleCircle color="#ccddfd" />
          </div>
          <div class="col">
            <StyleCircle color="#c7d1e1" />
          </div>
          <div class="col">
            <StyleCircle color="#e6c7ff" />
          </div>
        </div>
        <div class="row">
          <div class="col">
            <StyleCircle color="#DC3545" />
          </div>
        </div>
        <h6>
          Länkar
        </h6>
        <TextContainer>
          <a href="#">Länk</a>
        </TextContainer>
        <h6>
          Knappar
        </h6>
        <div class="buttons">
          <span>Default</span>
          <div>
            <button class="btn btn-primary">Lorem ipsum</button> <button class="btn btn-secondary">Lorem ipsum</button> <button class="btn btn-danger">Lorem ipsum</button> <button class="btn" disabled>Lorem ipsum</button>
          </div>
        </div>
        <div class="buttons">
          <span>Small</span>
          <div>
            <button class="btn btn-small btn-primary">Lorem ipsum</button> <button class="btn btn-small btn-secondary">Lorem ipsum</button> <button class="btn btn-small btn-danger">Lorem ipsum</button> <button class="btn btn-small" disabled>Lorem ipsum</button>
          </div>
        </div>
        <div class="buttons">
          <span>Knapp med ikon</span>
          <div>
            <button class="btn btn-primary"><i class="fa-light fa-plus mr-1"></i>Create new</button> <span><button class="btn btn-small btn-primary"><i class="fa-light fa-plus mr-1"></i>Create new</button></span>
          </div>
        </div>
        <h6>
          Accordion
        </h6>
        <Accordion></Accordion>
        <h6 class="d-none">
          Tabell 1A
        </h6>
        <StyleGuideTable></StyleGuideTable>
        <h6>
          Tabell 1
        </h6>
        <TableB />
        <h6>
          Tabell 2
        </h6>
        <div class="editable">
          <div class="row">
            <label
              class="col-12 col-md-3"
            >
              Lorem Ipsum
            </label>
            <input
              class="form-control col-12 col-md-9"
              v-model="test4"
              readonly
            />
          </div>
          <div class="row">
            <label
              class="col-12 col-md-3"
            >
              Lorem Ipsum
            </label>
            <input
              class="form-control col-12 col-md-9"
              v-model="test5"
              readonly
            />
          </div>
          <div class="row">
            <label
              class="col-12 col-md-3"
            >
              Lorem Ipsum
            </label>
            <input
              class="form-control col-12 col-md-9"
              v-model="test6"
              readonly
            />
          </div>
          <button class="btn btn-small btn-secondary" type="submit">Edit</button>
        </div>
        <StyleGuideForm></StyleGuideForm>
        <h6>
          Alert
        </h6>
        <div
          class="col-12 col-sm-6 col-md-4 col-xl-4 bg-warning alert pb-2 pt-2 text-center"
        >
        <i class="fa-regular fa-clock mr-1"></i>
          Scheduled 08:00 2021-10-30
        </div>
        <h6>
          Hjälpikon
        </h6>
            <a class="help-text" href="#">
              Delete
              <i class="fa-regular fa-circle-question" v-b-tooltip="'Delete member'"></i>
            </a>
        <h6>
          Charts
        </h6>
        <div class="row mt-5">
          <Chart
            class="col-md-4"
            :sub="0"
            :total="3"
           />
           <Chart
            class="col-md-4"
            :sub="3"
            :total="4"
           />
           <Chart
            class="col-md-4"
            :sub="4"
            :total="4"
           />
        </div>
        <h6>
          Kodfält
        </h6>
        <CodeInput
        :length="6"
        />
        <h6>
          Progress bar
        </h6>
        <div class="progress gdq-progress-bar" style="height: 1rem;">
          <div 
            class="progress-bar bg-info" 
            role="progressbar" 
            :style="`width: ${(5/60)*100}%`"
            :aria-valuenow="5" 
            aria-valuemin="0" 
            :aria-valuemax="60"
          >
          </div>
        </div>
        <div class="text-sm text-right mt-2">
            5 of 60
        </div>
        <h6>
          Skala
        </h6>
        <Scale></Scale>
      </div>
    </div>
  </template>
<script>
import StyleCircle from './styleguide/Circle.vue'
import TextContainer from './TextContainer.vue'
import Accordion from './styleguide/Accordion.vue'
import StyleGuideTable from './styleguide/Table.vue'
import StyleGuideForm from './styleguide/FormDemo.vue'
import CodeInput from './styleguide/CodeInput.vue'
import Scale from './styleguide/Scale.vue'
import NavbarNew from './styleguide/NavbarNew.vue'
import Chart from './styleguide/Chart.vue'
import TableB from './styleguide/TableB.vue'

export default {
  data () {
    return {
      test4: 'Lorem ipsum',
      test5: 'Lorem ipsum',
      test6: 'Lorem ipsum'
    }
  },
  components: {
    TextContainer,
    StyleCircle,
    Accordion,
    StyleGuideTable,
    TableB,
    StyleGuideForm,
    CodeInput,
    Scale,
    Chart,
    NavbarNew
  }
}
</script>
